import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { post } from  "../../lib/request"

export const hideUnhideMessage = createAsyncThunk(
  "messageHide/hideUnhideMessage",
  async ({ messageId, hide,channel }, { rejectWithValue }) => {
    try {

      await post(
        `${channel}/messages/${messageId}/hide-unhide?hide=${hide}`,
        {
          headers: {
            accept: "*/*",
          },
        }
      );

      return { messageId, hide };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const messageHideSlice = createSlice({
  name: "messageHide",
  initialState: {
    hiddenMessageIds: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hideUnhideMessage.pending, (state) => {
        state.loading = true;
      })
      .addCase(hideUnhideMessage.fulfilled, (state, action) => {
        const { messageId, hide } = action.payload;
        state.loading = false;

        if (hide) {
          if (!state.hiddenMessageIds.includes(messageId)) {
            state.hiddenMessageIds.push(messageId);
          }
        } else {
          state.hiddenMessageIds = state.hiddenMessageIds.filter(
            (id) => id !== messageId
          );
        }
      })
      .addCase(hideUnhideMessage.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default messageHideSlice.reducer;
